<template>
  <BAutocompleteSelect
    ref="autocomplete"
    v-bind="$attrs"
    label="Тип ячейки"
    no-data-text="Тип не найден"
    :options="options"
    :return-object="false"
    item-text="label"
    item-value="value"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { SheetCellTypesOptions } from '@/typings/api/FormTemplate'

import BAutocompleteSelect from './BAutocompleteSelect.vue'


export default {
  name: 'BAutocompleteSheetCellType',
  components: {
    BAutocompleteSelect,
  },
  mixins: [
    openApiMixin,
  ],
  data: () => ({
    options: Object.values(SheetCellTypesOptions),
  }),
}
</script>
